/* One class, .is-stuck, on the site header once the page has moved.

   WHY THIS IS NOT CSS. A sticky element cannot tell you whether it is
   currently stuck: there is no :stuck pseudo class, and the scroll driven
   animation that would do it (animation-timeline: scroll()) is not in every
   browser this store has to serve. A scroll listener is four lines and works
   everywhere.

   IT IS NOT A LISTENER PER FRAME EITHER. The handler does nothing but compare
   a boolean, and it only touches the DOM when the answer changes, so the
   common case is a comparison and a return. passive: true so it never blocks
   the scroll itself.

   The modal's own header does not need this: the app extension already puts
   .is-floating on its toolbar the moment its scroller moves, and
   fx-ext-fine.css hangs the same shadow off that. */
(function () {
  var THRESHOLD = 4;
  var stuck = false;
  var els = [];

  function apply() {
    var now = (window.scrollY || window.pageYOffset || 0) > THRESHOLD;
    if (now === stuck) return;
    stuck = now;
    for (var i = 0; i < els.length; i++) {
      els[i].classList.toggle('is-stuck', stuck);
    }
  }

  function boot() {
    els = [].slice.call(document.querySelectorAll('.fx-hdr'));
    if (!els.length) return;
    window.addEventListener('scroll', apply, { passive: true });
    window.addEventListener('resize', apply);
    apply();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
